import { render, staticRenderFns } from "./SdCoordinate.vue?vue&type=template&id=ba8ab47e"
import script from "./SdCoordinate.vue?vue&type=script&lang=js"
export * from "./SdCoordinate.vue?vue&type=script&lang=js"
import style0 from "./SdCoordinate.vue?vue&type=style&index=0&id=ba8ab47e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports